import { request, RequestError, RequestErrorType } from '@tencent/vft-common/request'
import login from '@tencent/vft-common/login'
import util from '@tencent/vft-common/util'
let acessCgiHost = +util.getUrlParam('sandbox') === 1 ? '//debugaccess.video.qq.com' : '//access.video.qq.com'

export function useTicket (cover) {
  return request(acessCgiHost + '/trans/pay.video.qq.com/fcgi-bin/ticket_trade?vappid=68106135&vsecret=e667570eb833960cc41051d498df1c233308eb195dba2cc3', {
    uin: login.getUin(),
    cid: util.getUrlParam('cid'),
    pid: 10001,
    pchannel: 'ticket',
    money: '',
    title: cover.title,
    days: '',
    tid: '',
    aid: util.getUrlParam('aid'),
    g_tk: login.getToken(),
    otype: 'json'
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (res.ret !== 0) {
      throw new RequestError(res.result.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res
  })
}

export function queryTicket () {
  return request(acessCgiHost + '/trans/pay.video.qq.com/fcgi-bin/user_ticket?vappid=68106135&vsecret=e667570eb833960cc41051d498df1c233308eb195dba2cc3', {
    uin: login.getUin(),
    status: 1,
    _t: 5,
    otype: 'json',
    g_tk: login.getToken(),
    low_login: 1
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (!res.result || res.result.code !== 0) {
      throw new RequestError(res.result.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res
  })
}

export function checkPay (cid) {
  return request(acessCgiHost + '/trans/pay.video.qq.com/fcgi-bin/pay?vappid=68106135&vsecret=e667570eb833960cc41051d498df1c233308eb195dba2cc3&otype=json', {
    id: cid,
    uin: login.getUin(),
    g_tk: login.getToken()
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (!res.result || res.result.code !== 0) {
      throw new RequestError(res.result.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res.pay
  })
}
